'use client';

import type { ComponentProps } from 'react';

import { MHButton } from '../buttons/MHButton';

export function SecondaryButton(props: ComponentProps<typeof MHButton>) {
  return <MHButton variant="secondary" {...props} />;
}
